import { useEffect, useState } from 'react';
import { loadPlanPalletChecks } from './palletCheckData';

/**
 * The SO page's pallet checks: {pallet_id: {last_check, open_problems}} for a packing plan, {} until it
 * answers and {} for good when the call fails (GET /packaging/plans/{id}/pallet_checks may not be on prod
 * yet). Feeds the "Problem reported" chip on the desktop pallet card and the phone PalletCard.
 */
export default function usePalletChecks(planId) {
  const [checks, setChecks] = useState({});
  useEffect(() => {
    let alive = true;
    setChecks({});
    if (!planId) return undefined;
    loadPlanPalletChecks(planId).then((c) => { if (alive) setChecks(c || {}); }).catch(() => {});
    return () => { alive = false; };
  }, [planId]);
  return checks;
}
